import { newWebAction } from "../../../../../../common/factory/action.factory";
import { addNewVariable } from "../../../../../../common/factory/variable.factory";
import { ActionRenderOptions } from "../../../../../../common/constants/core/action.constants";
import { PaginationType } from "../../../../../../common/interfaces/flow/action/WebRequestAction";
import { createFlowPayload,createFlowInstance} from "../../../payload/generic.flow"
import {createPagination} from "../../../../../../integrations/flow/edit/action/tabs/behavioursTab/pagination/utils/paginationUtil"
import importMappingConfig from "./userImportMappingConfig.json"
export const createImportFlowPayload = (currentData,importSourceName, assetSchema, objectTypeName, workspaceId, importSourceId,importCredentialObject,patTokenCredentialObject) => {
    
    //init flow
    let flow = createFlowInstance(currentData.cron,
        "Jira Asset Import: "+objectTypeName,
        "This integration imports from API into Jira Assets and place them in the Asset Schema: "+assetSchema.label+" in the Object Type: "+objectTypeName+"\nThe Import Source is called "+importSourceName)

    //console.log(flow)
    //create custom get data, e.g fetch jira users
    const getFromAPI = newWebAction(flow, "Get "+objectTypeName, null, ActionRenderOptions[0].value);
    getFromAPI.method = "GET"
    getFromAPI.url = currentData.url;

    //create custom submit data for how the data is submitted, note body needs to match the selector. e.g users
    const submitUsers = newWebAction(flow, "Submit Data", getFromAPI.id, ActionRenderOptions[0].value);
    submitUsers.method = "POST"
    addNewVariable(submitUsers,"submitResultsUrl","$.links.submitResults")
    submitUsers.url = "{{submitResultsUrl}}"
    submitUsers.credentialsReference = importCredentialObject
    submitUsers.body = "{\n    \"data\":{\n        \"api_response\":{{{toJSON payload}}}\n    }\n}"

    //replace the input parametes in the json file
    importMappingConfig.schema.objectSchema.name = assetSchema.name
    importMappingConfig.schema.objectSchema.objectTypes[0].name = objectTypeName
    importMappingConfig.mapping.objectTypeMappings[0].objectTypeName = objectTypeName


    const customActionObjects = [{
        fetchAction: getFromAPI,
        childActions: [submitUsers]
    }]
    
    //console.log(importCredentialObject)
    const customImport = {
        importMappingConfig:JSON.stringify(importMappingConfig, null, 2),
        customActionObjects:customActionObjects
    }
    //console.log(customImport)
    return createFlowPayload(flow,
        workspaceId, 
        importSourceId,
        importCredentialObject,
        customImport)

}